module.exports = __webpack_public_path__ + "img/popular-categories-1.74aa4288.png";